import {Action, getModule, Module, Mutation, MutationAction, VuexModule} from 'vuex-module-decorators';
import store from '@/model/store/store';
import api from '@/model/api';
import {GCIHeaderRes, GCIHeaderInfoRes, GCIHeaderListsInfoRes} from '@/model/dto/res/header/get-header-info-res';
import {PUIHDataReq, PostUpsertHeaderReq} from '@/model/dto/req/header/post-upsert-header-req';
import {PUIHIDataReq, PostUploadImageHeaderReq} from '@/model/dto/req/header/post-upload-image-header-req';
import {PostUploadImageHeaderRes, PostUploadImageHeaderInfoRes} from '@/model/dto/res/header/post-upload-image-header-res';
import {SearchQueryInterface} from '@/model/interfaces/search-interface';

@Module({dynamic: true, store, namespaced: true, name: 'HeaderModule'})
class HeaderModule extends VuexModule {

  public header: string = ''; // ID
  public headerListsInfo: GCIHeaderRes[] = [];
  public headerInfo: GCIHeaderRes = {
    id: 0,
    title: '',
    text: '',
    path: '',
    status: 0,
    deleted: false
  };
  public uploadImageInfo: PostUploadImageHeaderRes = {
    status: 0,
    message: '',
    path: ''
  };
  public upsertStatus: number = 0;
  public isHeaderDialog: boolean = false;
  public headerTargetId: number = 0;

  // Mutations
  @Mutation
  private setHeader(header: GCIHeaderRes): void {
    this.headerInfo = header;
  }

  @Mutation
  private setHeaderTitle(str: string): void {
    this.headerInfo.title = str;
  }

  @Mutation
  private setHeaderText(str: string): void {
    this.headerInfo.text = str;
  }

  @Mutation
  private setIsHeaderDialog(state: boolean): void {
    this.isHeaderDialog = state;
  }

  @Mutation
  private setHeaderTargetId(num: number): void {
    this.headerTargetId = num;
  }

  // Actions
  /**
   * コンテンツの初期化
   *
   * @param param
   */
   @Action({ rawError: true })
   public pushHeader(
     header: GCIHeaderRes
   ): void {
     this.setHeader(header);
   }
  /**
   * コンテンツの初期化
   *
   * @param param
   */
   @Action({ rawError: true })
   public pushHeaderTitle(
     str: string
   ): void {
     this.setHeaderTitle(str);
   }

   @Action({ rawError: true })
   public pushHeaderText(
     str: string
   ): void {
     this.setHeaderText(str);
   }

   @Action
   public updateIsHeaderDialog(state: boolean): void {
     this.setIsHeaderDialog(state);
   }

   @Action
   public updateHeaderTargetId(num: number): void {
     this.setHeaderTargetId(num);
   }

   /**
    * コンテンツ情報をリクエスト
    *
    * TODO:
    */
   @MutationAction({ rawError: true })
   public async requestHeaderListsInfo(param: SearchQueryInterface): Promise<any> {
     try {
       const info = await api.getHeaderListsInfo(param);
       return {
         headerListsInfo: info.lists
       };
     } catch (err) {
       throw err;
     }
   }

  /**
   * コンテンツ情報をリクエスト
   *
   * TODO:
   */
  @MutationAction({ rawError: true })
  public async requestHeaderInfo(id: number): Promise<any> {
    try {
      const info = await api.getHeaderInfo(id);
      return {
        headerInfo: info.results
      };
    } catch (err) {
      throw err;
    }
  }

  /**
   * ヘッダー情報追加をリクエスト
   */
  @MutationAction({ rawError: true })
  public async requestUpsertHeaderInfo(
    param: PUIHDataReq
  ): Promise<any> {
    try {
      const data = await api.postUpsertHeaderInfo(param);
      let status: number = data?.results.status ?? 0;
      if (status === 0) { status = Math.floor( Math.random() * 101 ); }
      return {
        upsertStatus: status
      };
    } catch (err) {
      throw err;
    }
  }

  /**
   * コンテンツ内の画像アップロードをリクエスト
   */
  @MutationAction({ rawError: true })
  public async requestUploadImageHeaderInfo(
    param: {
      file: File,
      id: string
    }
  ): Promise<any> {
    try {
      const res = await api.postUploadImageHeaderInfo(param);
      res.results.status = Math.floor( Math.random() * 101 );
      return {
        uploadImageInfo: res.results
      };
    } catch (err) {
      throw err;
    }
  }

  /**
   * ヘッダー情報削除をリクエスト
   */
  @MutationAction({ rawError: true })
  public async requestDeleteHeaderInfo(
    param: PUIHDataReq
  ): Promise<any> {
    try {
      const data = await api.postDeleteImageHeaderInfo(param);
      let status: number = data?.results.status ?? 0;
      if (status === 0) { status = Math.floor( Math.random() * 101 ); }
      return {
        upsertStatus: status
      };
    } catch (err) {
      throw err;
    }
  }

}

export default getModule(HeaderModule, store);
